"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CopyButton = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _button = _interopRequireDefault(require("britive-design-system/core/components/button"));

var _io = require("react-icons/io5");

var _constants = require("../constants");

var _utils = require("../../../utils");

var _action = require("../../../../../../../components/notification/action");

var _reactRedux = require("react-redux");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CopyButton = function CopyButton(_ref) {
  var secretDetailData = _ref.secretDetailData,
      templateParameter = _ref.templateParameter;
  var dispatch = (0, _reactRedux.useDispatch)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.copyButton
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    variant: 'textOnly',
    onClick: function onClick() {
      var toBeCopiedValue = (0, _utils.secretValueCopyHandler)(secretDetailData, templateParameter);
      toBeCopiedValue && navigator.clipboard.writeText(toBeCopiedValue);
      toBeCopiedValue && dispatch((0, _action.openNotification)(_constants.secretListConstants.successText, _constants.translatedStrings.copyNotificationMessage, _constants.copyNotificationTime));
    },
    size: 'small'
  }, /*#__PURE__*/_react.default.createElement(_io.IoCopyOutline, {
    size: _constants.copyIconSize
  })));
};

exports.CopyButton = CopyButton;
CopyButton.propTypes = {
  secretDetailData: _propTypes.default.object,
  templateParameter: _propTypes.default.object
};